export type Locale = 'ar' | 'en';

export const translations = {
  ar: {
    // Auth
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    companyName: 'اسم الشركة',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    loginHere: 'سجّل الدخول هنا',
    signupHere: 'أنشئ حساباً هنا',
    demoCredentials: 'بيانات تجريبية',
    useCredentials: 'استخدام',
    invalidCredentials: 'بيانات غير صحيحة — استخدم الحسابات التجريبية أدناه',
    emailRequired: 'البريد الإلكتروني مطلوب',
    emailInvalid: 'بريد إلكتروني غير صالح',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordMin: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
    nameRequired: 'الاسم مطلوب',
    companyRequired: 'اسم الشركة مطلوب',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    loginSuccess: 'مرحباً بك في DayFlow',
    tagline: 'أدِر مهامك بذكاء واحترافية',
    heroDesc: 'منصة SaaS متكاملة لإدارة المهام والمشاريع والفرق — اشتراك واحد يكفيك',
    feature1: 'لوحة تحكم متعددة الفرق',
    feature2: 'إدارة الخطط والاشتراكات',
    feature3: 'تحكم كامل في الأدوار والصلاحيات',
    feature4: 'تقارير MRR في الوقت الفعلي',
    // Dashboard
    dashboard: 'لوحة التحكم',
    tenants: 'الفرق',
    subscriptions: 'الاشتراكات',
    users: 'المستخدمون',
    settings: 'الإعدادات',
    signOut: 'تسجيل الخروج',
    mrr: 'الإيراد الشهري المتكرر',
    activeTenants: 'الفرق النشطة',
    newSignups: 'تسجيلات جديدة (30 يوم)',
    suspendedTenants: 'الفرق الموقوفة',
    seatUtilization: 'معدل استخدام المقاعد',
    churnRate: 'معدل التسرب',
    tenantName: 'اسم الفريق',
    plan: 'الخطة',
        owner: 'القائد',
    seats: 'المقاعد',
    status: 'الحالة',
    mrrContrib: 'مساهمة MRR',
    created: 'تاريخ الإنشاء',
    actions: 'الإجراءات',
    search: 'بحث...',
    filterByPlan: 'تصفية حسب الخطة',
    filterByStatus: 'تصفية حسب الحالة',
    allPlans: 'جميع الخطط',
    allStatuses: 'جميع الحالات',
    individual: 'فردي',
    smallTeam: 'فريق صغير',
    mediumTeam: 'فريق متوسط',
    active: 'نشط',
    suspended: 'موقوف',
    expired: 'منتهي',
    trial: 'تجريبي',
    suspend: 'إيقاف',
    activate: 'تفعيل',
    upgrade: 'ترقية',
    downgrade: 'تخفيض',
    delete: 'حذف',
    recentActivity: 'النشاط الأخير',
    mrrTrend: 'اتجاه MRR الأسبوعي',
    planDistribution: 'توزيع الخطط',
    // Tenant Owner
    activeMembers: 'الأعضاء النشطون',
    seatsUsed: 'المقاعد المستخدمة',
    daysUntilRenewal: 'أيام حتى التجديد',
    planTier: 'مستوى الخطة',
    subscriptionStatus: 'حالة الاشتراك',
    renewalDate: 'تاريخ التجديد',
    inviteMember: 'دعوة عضو',
    memberName: 'اسم العضو',
    memberEmail: 'بريد العضو',
    role: 'الدور',
    lastActive: 'آخر نشاط',
    member: 'عضو',
        tenantOwner: 'قائد الفريق',
    superAdmin: 'المشرف العام',
    upgradePlan: 'ترقية الخطة',
    currentPlan: 'الخطة الحالية',
    seatsAvailable: 'المقاعد المتاحة',
    teamManagement: 'إدارة الفريق',
    inviteByEmail: 'البريد الإلكتروني للدعوة',
    selectRole: 'اختر الدور',
    sendInvite: 'إرسال الدعوة',
    cancel: 'إلغاء',
    save: 'حفظ',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    thisActionIrreversible: 'هذا الإجراء لا يمكن التراجع عنه',
    confirm: 'تأكيد',
    lastUpdated: 'آخر تحديث',
    superAdminDashboard: 'لوحة تحكم المشرف العام',
    tenantDashboard: 'لوحة تحكم الفريق',
    noTenantsFound: 'لم يتم العثور على فرق',
    noMembersFound: 'لم يتم العثور على أعضاء',
    // DayFlow Productivity
    dailyPlanner: 'المخطط اليومي',
    tasks: 'المهام',
    timeManagement: 'إدارة الوقت',
    focusMode: 'وضع التركيز',
    dailyProgress: 'التقدم اليومي',
    productivity: 'الإنتاجية',
    billing: 'الفواتير',
    teamAnalytics: 'تحليلات الفريق',
    systemUsers: 'مستخدمي النظام',
    totalUsers: 'إجمالي المستخدمين',
    globalOverview: 'نظرة عامة على النظام',
    workspaces: 'مساحات العمل',
    userManagement: 'إدارة المستخدمين',
    allUsers: 'جميع المستخدمين',
    workspaceAffiliation: 'الفريق التابع له',
    refresh: 'تحديث',
  },
  en: {
    login: 'Sign In',
    signup: 'Sign Up',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    companyName: 'Company Name',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    loginHere: 'Sign in here',
    signupHere: 'Create an account',
    demoCredentials: 'Demo Credentials',
    useCredentials: 'Use',
    invalidCredentials: 'Invalid credentials — use the demo accounts below to sign in',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email address',
    passwordRequired: 'Password is required',
    passwordMin: 'Password must be at least 8 characters',
    nameRequired: 'Name is required',
    companyRequired: 'Company name is required',
    passwordMismatch: 'Passwords do not match',
    loginSuccess: 'Welcome to DayFlow',
    tagline: 'Manage Your Tasks Smarter',
    heroDesc: 'DayFlow is a task management SaaS platform — organize tasks, track progress, and collaborate with your team under one subscription',
    feature1: 'Multi-workspace control panel',
    feature2: 'Plan & subscription management',
    feature3: 'Full role-based access control',
    feature4: 'Real-time MRR reporting',
    dashboard: 'Dashboard',
    tenants: 'Workspaces',
    subscriptions: 'Subscriptions',
    users: 'Users',
    settings: 'Settings',
    signOut: 'Sign Out',
    mrr: 'Monthly Recurring Revenue',
    activeTenants: 'Active Workspaces',
    newSignups: 'New Signups (30d)',
    suspendedTenants: 'Suspended Workspaces',
    seatUtilization: 'Seat Utilization Rate',
    churnRate: 'Churn Rate',
    tenantName: 'Workspace Name',
    plan: 'Plan',
    owner: 'Owner',
    seats: 'Seats',
    status: 'Status',
    mrrContrib: 'MRR Contribution',
    created: 'Created',
    actions: 'Actions',
    search: 'Search...',
    filterByPlan: 'Filter by Plan',
    filterByStatus: 'Filter by Status',
    allPlans: 'All Plans',
    allStatuses: 'All Statuses',
    individual: 'Individual',
    smallTeam: 'Small Team',
    mediumTeam: 'Medium Team',
    active: 'Active',
    suspended: 'Suspended',
    expired: 'Expired',
    trial: 'Trial',
    suspend: 'Suspend',
    activate: 'Activate',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    delete: 'Delete',
    recentActivity: 'Recent Activity',
    mrrTrend: 'Weekly MRR Trend',
    planDistribution: 'Plan Distribution',
    activeMembers: 'Active Members',
    seatsUsed: 'Seats Used',
    daysUntilRenewal: 'Days Until Renewal',
    planTier: 'Plan Tier',
    subscriptionStatus: 'Subscription Status',
    renewalDate: 'Renewal Date',
    inviteMember: 'Invite Member',
    memberName: 'Member Name',
    memberEmail: 'Member Email',
    role: 'Role',
    lastActive: 'Last Active',
    member: 'Member',
    tenantOwner: 'Team Leader',
    superAdmin: 'Super Admin',
    upgradePlan: 'Upgrade Plan',
    currentPlan: 'Current Plan',
    seatsAvailable: 'Seats Available',
    teamManagement: 'Team Management',
    inviteByEmail: 'Invite by Email',
    selectRole: 'Select Role',
    sendInvite: 'Send Invite',
    cancel: 'Cancel',
    save: 'Save',
    confirmDelete: 'Are you sure you want to delete?',
    thisActionIrreversible: 'This action cannot be undone',
    confirm: 'Confirm',
    lastUpdated: 'Last updated',
    superAdminDashboard: 'Super Admin Dashboard',
    tenantDashboard: 'Workspace Dashboard',
    noTenantsFound: 'No workspaces found',
    noMembersFound: 'No members found',
    // DayFlow Productivity
    dailyPlanner: 'Daily Planner',
    tasks: 'Tasks',
    timeManagement: 'Time Management',
    focusMode: 'Focus Mode',
    dailyProgress: 'Daily Progress',
    productivity: 'Productivity',
    billing: 'Billing',
    teamAnalytics: 'Team Analytics',
    systemUsers: 'System Users',
    totalUsers: 'Total Users',
    globalOverview: 'Global Overview',
    workspaces: 'Workspaces',
    userManagement: 'User Management',
    allUsers: 'All Users',
    workspaceAffiliation: 'Workspace Affiliation',
    refresh: 'Refresh',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

export function t(key: TranslationKey, locale: Locale): string {
  return translations[locale][key] ?? translations.en[key] ?? key;
}